import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill", "height", "width"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M36.8415 44.8627L50.0008 25.1236C50.5178 24.3481 50.3083 23.3004 49.5328 22.7835C49.2556 22.5987 48.9299 22.5 48.5968 22.5L38.2499 22.5L38.2499 10.0735C38.2499 9.1415 37.4944 8.38598 36.5624 8.38598C35.9982 8.38598 35.4713 8.66797 35.1583 9.13743L21.9989 28.8765C21.482 29.6519 21.6915 30.6997 22.467 31.2166C22.7442 31.4014 23.0699 31.5001 23.403 31.5001L33.7499 31.5L33.7499 43.9266C33.7499 44.8586 34.5054 45.6141 35.4374 45.6141C36.0016 45.6141 36.5285 45.3321 36.8415 44.8627Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.125 11.25L21.375 11.25C23.239 11.25 24.75 12.761 24.75 14.625C24.75 16.489 23.239 18 21.375 18L10.125 18C8.26104 18 6.75 16.489 6.75 14.625C6.75 12.761 8.26104 11.25 10.125 11.25ZM10.125 38.25L21.375 38.25C23.239 38.25 24.75 39.761 24.75 41.625C24.75 43.489 23.239 45 21.375 45L10.125 45C8.26105 45 6.75001 43.489 6.75001 41.625C6.75001 39.761 8.26104 38.25 10.125 38.25ZM5.625 24.75L14.625 24.75C16.489 24.75 18 26.261 18 28.125C18 29.989 16.489 31.5 14.625 31.5L5.625 31.5C3.76104 31.5 2.25 29.989 2.25 28.125C2.25 26.261 3.76104 24.75 5.625 24.75Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 54 54",
    fill: _ctx.color,
    height: _ctx.size,
    width: _ctx.size,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, _hoisted_4, 8, _hoisted_1))
}